module.exports = __webpack_public_path__ + "static/media/visamc.06726167.png";